
import ViewBase from "../../../../framework/core/mvvm/view_base";
import Q2TableResultItem from "./q2_table_result_item";
import Q2TableResultDetailItem from "./q2_table_result_detail_item";
import { Q2ColorSliderComponent } from "../table/com/q2_colorslider_component";
import { Q2Game } from "../../net/proto/q2_game";
import ModelData from "../../../public/model_data";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/q2/Q2TableResultView')
export default class Q2TableResultView extends ViewBase {

    @property(cc.Node)
    nodeResultPanel: cc.Node = null

    @property(cc.Node)
    nodeDetailPanel: cc.Node = null

    @property([Q2TableResultItem])
    resultItemList: Q2TableResultItem[] = []

    @property([Q2TableResultDetailItem])
    resultDetailItemList: Q2TableResultDetailItem[] = []

    @property(Q2ColorSliderComponent)
    timeOutSlider: Q2ColorSliderComponent = null

    @property(cc.Label)
    labelSecs: cc.Label = null

    @property(cc.Node)
    nodeWinTitle: cc.Node = null

    @property(cc.Node)
    nodeLoseTitle: cc.Node = null

    protected m_last_timeout_id: number = 0

    refreshLeftSecs(leftSecs: number, onFinish: Function){
        let self = this
        leftSecs = Math.max(Math.ceil(leftSecs), 0)
        self.labelSecs.string = leftSecs.toString()
        if(leftSecs == 0){
            onFinish && onFinish()
            return            
        }
        if(self.m_last_timeout_id){
            self.cancelSchedule(self.m_last_timeout_id)
            self.m_last_timeout_id = 0
        }
        self.m_last_timeout_id = self.doScheduleOnce(()=>{
            leftSecs--
            self.refreshLeftSecs(leftSecs, onFinish)
        }, 1)
    }

    showTimeOutSlider(leftSecs: number, totalSecs: number, onFinish: Function){
        let self = this
        this.timeOutSlider.node.active = false
        this.timeOutSlider.setOpTime(leftSecs, totalSecs, function(){

        }, function(leftSecs: number){
            
        })
        this.refreshLeftSecs(leftSecs, onFinish)
    }

    showResultPanel(show: boolean, data?: any, firstShow?: boolean){
        this.nodeResultPanel.active = !!show
        if(show){
            for (let index = 0; index < this.resultItemList.length; index++) {
                const item = this.resultItemList[index];
                item.show(false)
            }
            let settleData = data.settleData as Q2Game.IGameSettle
            let seatPosMap = data.seatPosMap
            settleData.seatList.sort(function(a, b){
                return b.balance - a.balance
            })
            for (let index = 0; index < settleData.seatList.length; index++) {
                const seatData = settleData.seatList[index];
                if(ModelData.instance.roleData.id == seatData.playerId){
                    this.nodeWinTitle.active = seatData.balance >= 0
                    this.nodeLoseTitle.active = seatData.balance < 0
                }
                let localPos = seatPosMap[seatData.seatId]
                let item = this.resultItemList[localPos]
                item.show(true, seatData, index + 1, data.isMango, settleData.completeSeatId, firstShow)
            }

        }
    }

    showDetailPanel(show: boolean, data?: any){
        this.nodeDetailPanel.active = !!show
        if(show){
            for (let index = 0; index < this.resultDetailItemList.length; index++) {
                const item = this.resultDetailItemList[index];
                item.show(false)
            }
            let settleData = data.settleData as Q2Game.IGameSettle
            let seatPosMap = data.seatPosMap
            settleData.seatList.sort(function(a, b){
                return b.balance - a.balance
            })
            for (let index = 0; index < settleData.seatList.length; index++) {
                const seatData = settleData.seatList[index];
                let localPos = seatPosMap[seatData.seatId]
                let item = this.resultDetailItemList[localPos]
                item.show(true, seatData, index + 1)
            }
        }
    }
}
